import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Type, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AngularBlockListType } from 'src/app/models/enums/angularBlockListType';
import { DataService } from 'src/app/shared/services/data.service';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { RenderService } from 'src/app/shared/services/render.service';
import { environment } from 'src/environments/environment';
import { BlockListType } from '../../models/enums/blockListType';
import { DocumentPageType } from 'src/app/models/enums/documentPageType';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { CurrentPageService } from 'src/app/shared/services/current-page.service';
import { PortalSeoHelper } from 'src/app/utils/helpers/portal-seo.helper';

@Component({
  selector: 'app-standard-content-page',
  templateUrl: './standard-content-page.component.html',
  styleUrls: [
  './standard-content-page.component.scss', 
  './standard-content-page-blocklists.scss', 
  './standard-content-page-blocklists-combinations.scss', 
  './standard-content-page.component.en.scss',
  './standard-content-page-blocklists.en.scss'],
})
export class StandardContentPageComponent implements OnInit {
  private routeSubscription: Subscription | undefined;
  isMobile: boolean = false;
  constructor(
    private dataService: DataService,
    private renderService: RenderService,
    private routerService: RouterService,
    private route: ActivatedRoute,
    private router: Router,
    private userAgentService: UserAgentService,
    private currentPageService: CurrentPageService,
    private portalSeoHelper: PortalSeoHelper
  ) {
    this.isMobile = this.userAgentService.isMobileDevice();
  }

  @Input() isPreview: boolean = false;
  @Input() pageUrl: string | null = null;
  @ViewChild('pageDataContainer') pageDataContainer!: ElementRef;
  blockListType = BlockListType;
  angularBlockListType = AngularBlockListType;
  currentRoute: string = '';
  pageData: any;
  generalSettingsData: any;
  DocumentPageType = DocumentPageType;
  groupedBlocks: any[][] = [];
  isLoading: boolean = true;

  ngOnInit() {
    //console.log('stand content page init init again');
    this.reloadComponent();
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.reloadComponent();
      }
    });
    this.dataService.updateGeneralSettingsData$.subscribe((value) => {
      this.generalSettingsData = value;
    });
  }
  
  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }

    this.currentPageService.setPageManagesTitle(false);
  }

  getData(url: string) {
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      //pageUrl: this.pageUrl?.split('?')[0] ?? this.currentRoute.split('?')[0],
      pageUrl: this.pageUrl?.replace('/private/en', '') ?? this.routerService.getCurrentComponentRoute()
    };
    request.pageUrl = request.pageUrl.split("#")[0];
    this.isLoading = true;

    this.dataService.getDataByToken(url, request, false).subscribe({
      next: (data) => {
        data = JSON.parse(data);
        if (data.redirectToPage) {
          this.router.navigateByUrl(data.redirectToPage);
          return;
        }
        this.pageData = data;
        this.currentPageService.setPageManagesTitle(
          this.portalSeoHelper.isPortalStandardContentPage(this.pageData)
        );
        this.dataService.currentPageNodeId = data.pageNodeId;
        this.pageData.blockLists.forEach((x: { index: number; }, i: number) => { x.index = i });
        this.groupedBlocks = this.groupBlocks();

        //if general settings is still loading => wait for the load
        if(!this.generalSettingsData)
        {
          this.dataService.updateGeneralSettingsData$.subscribe((value) => {
            if(!value) return;
            this.generalSettingsData = value;
            this.pageLoadedHandler();
          });
        }
        else {
          this.pageLoadedHandler();
        }

        
      },
      error: (e) => console.error(e),
    });
  }

  pageLoadedHandler() {
    if (this.portalSeoHelper.isPortalStandardContentPage(this.pageData)) {
      this.portalSeoHelper.updateSeoTags(this.pageData);
    } else {
      this.portalSeoHelper.clearSeoTags();
      this.portalSeoHelper.updateDefaultPortalTitle(this.generalSettingsData);
    }

    this.isLoading = false;
    setTimeout(() => {
      if (this.pageDataContainer && this.pageDataContainer.nativeElement) {
        this.renderService.bindMainScripts();
      }
    }, 0);

    setTimeout(() => {
      this.scrollToAnchor();
    }, 200)
  }

  scrollToAnchor() {
    let anchorId = this.route.snapshot.fragment;
    if (!anchorId) {
      return;
    }
    anchorId = anchorId.charAt(0).toLowerCase()+anchorId.slice(1);
    const blocklist = document.querySelector(`[blocklist-id="${anchorId}"]`);
    if(blocklist)
      blocklist.scrollIntoView({behavior: 'smooth'})
  }

  reloadComponent() {
    //console.log('stand content page reload again');
    const url = this.router.url;
    const segments = url.split('/');
    const privateIndex = segments.findIndex((segment) => segment === 'private');
    if (privateIndex !== -1 && privateIndex + 1 < segments.length) {
      this.currentRoute = segments.slice(privateIndex + 1).join('/');
    } else {
      // Handle case when "private" segment is not found or there are no segments after it
    }

    let getDataUrl = environment.apiUrl;
    if(!this.isPreview) {
      getDataUrl += '/umbraco/Surface/MainPortalSurface/GetPageData';
    } else {
      getDataUrl += '/umbraco/Surface/PortalPreviewSurface/GetPreviewPageData';
    }
    this.pageData = null;
    this.getData(getDataUrl);
  }

  getMoodleLink(courseIdNumber: string) {
    this.dataService.getCourseMoodleUrl('1689').subscribe({
      next: (data) => {
        //data =JSON.parse(data)
      },
      error: (e) => console.error(e),
    });
  }

  getPageData(pageType: AngularBlockListType): any {
    let res = this.pageData.blockLists.filter((c: any) => c.angularComponentName != null).find(
      (c: any) =>
        c.angularComponentName.toLowerCase() ==
        AngularBlockListType[pageType].toLocaleLowerCase()
    );
    if (!res) {
      return null;
    }
    return res.angularBlockListData;
  }

  groupBlocks() {
    let currentRow = []; 
    let groupedBlocks = [];
    const aliasCount:any = {};

    for (const block of this.pageData.blockLists) {
      const alias = block.alias;
      if (!aliasCount[alias]) {
          aliasCount[alias] = 1;
          block.id = alias;
      } else {
          aliasCount[alias]++;
          block.id = `${alias}-${aliasCount[alias]}`;
      }

      if (!this.isMobile && block.angularBlockListData && (block.angularBlockListData?.partOfRow === 2 || block.angularBlockListData?.partOfRow === 3)) {
        currentRow.push(block);
      } else {
        if (currentRow.length > 0) {
          groupedBlocks.push([...currentRow]);
          currentRow = [];
        }
        groupedBlocks.push([block]);
      }
    }
    return groupedBlocks;
  }

  getCombinationClasses(block: { index: number; }) {
    const blocks = this.pageData.blockLists;
    const index = block.index;

    const currentAlias = blocks[index]?.alias;
    const prevAlias = blocks[index - 1]?.alias;
    const nextAlias = blocks[index + 1]?.alias;

    return {
      [`combination-current-${currentAlias}`]: !!currentAlias,
      [`combination-prev-${prevAlias}`]: !!prevAlias,
      [`combination-next-${nextAlias}`]: !!nextAlias,
      'combination-first': index === 0,
      'combination-last': index === blocks.length - 1
    };
  }
}